/** @format */

import React, { FC } from "react";
import { Tag } from "antd";
import { TIntermittentWorkerType } from "../../../../redux-modules/declarations/maps/intermittentCommunications";

/**
 * Colori diversi da quelli degli stati, per non confondere tipologia e stato.
 * Occasionale = viola, come nella lista Dipendenti (ViewUserList).
 */
const WORKER_TYPE_META: Record<TIntermittentWorkerType, { label: string; color: string }> = {
  intermittente: { label: "Intermittente", color: "geekblue" },
  occasionale: { label: "Occasionale", color: "purple" },
};

interface Props {
  types?: TIntermittentWorkerType[];
  small?: boolean;
}

export const WorkerTypeTags: FC<Props> = ({ types, small }) => {
  if (!types || !types.length) return <></>;

  return (
    <>
      {types.map(t => (
        <Tag
          key={t}
          color={WORKER_TYPE_META[t].color}
          style={{
            borderRadius: 7,
            marginRight: 4,
            ...(small ? { fontSize: 11, lineHeight: "16px", padding: "0 5px" } : {}),
          }}
        >
          {WORKER_TYPE_META[t].label}
        </Tag>
      ))}
    </>
  );
};
